export default "__VITE_ASSET__ByeUgNSn__"